import script from "./TheMyAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./TheMyAccount.vue?vue&type=script&setup=true&lang=js"

import "./TheMyAccount.vue?vue&type=style&index=0&id=3a6c9a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6c9a62"]])

export default __exports__